const initialState = {
    list: [],
    total: "",
    searchKey: "",
  };
  
  export const ManageSquadListReducer = (state = initialState, action) => {
    switch (action.type) {
      case "MANAGE_ALL_SQUADS_RESPONSE":
        return {
           
          ...state,
          list: [...action.data.list],
          total: action.data.total,
        };
  
      default:
        return state;
    }
  };
  
